/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import { useSelector } from "react-redux";
import { useDetectClickOutside } from "react-detect-click-outside";

import {
  _addCallParticipants,
  _callDocUpdate,
  // _updateCall,
} from "../../SocketIo";
import { globalStrings } from "../util/translation/languages";
import { alertMsg } from "../util/alertMsg";

const AddPeople = (props) => {
  const { handleClose, selectedLanguage } = props;
  const [AttendeeListForGroup, setAttendeeListForGroup] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const { allAttendeeList, callDetail } = useSelector((state) => state.call);

  const submitGroupUserForm = async (e) => {
    e.preventDefault();
    if (selectedOption) {
      let attendeeUser = [];
      selectedOption.forEach((so) => {
        let data = so.value;
        attendeeUser.push(data);
      });
      let allUser = [...attendeeUser];
      const removedDuplicateUsers = [...new Set(allUser)];
      let NewCallDetail = { ...callDetail };
      let participant = [];
      const tmpParticipant = [];
      if (callDetail.type === "private") {
        if (callDetail?.participantID?.length === 0) {
          tmpParticipant.push(
            {
              id: callDetail.senderID,
              status: callDetail.calling_status,
              hand_raise: false,
            },
            {
              id: callDetail.receiverID,
              status: callDetail.calling_status,
              hand_raise: callDetail.hand_raise,
            },
          );
          removedDuplicateUsers.forEach((item) => {
            let particularAttendeeData = allAttendeeList?.find(
              (filterItem) => filterItem.user_id === item,
            );
            const onCallCheck = particularAttendeeData?.onCall ?? false;
            if (!onCallCheck) {
              tmpParticipant.push({
                id: item,
                status: "initiated",
                hand_raise: false,
              });
            }
          });
        } else {
          participant = [...callDetail.participantID];
          removedDuplicateUsers.forEach((item) => {
            const isUserAlreadyExist = participant.findIndex(
              (filterItem) => filterItem.id === item,
            );
            if (isUserAlreadyExist === -1) {
              let particularAttendeeData = allAttendeeList?.find(
                (filterItem) => filterItem.user_id === item,
              );
              const onCallCheck = particularAttendeeData?.onCall ?? false;
              if (!onCallCheck) {
                tmpParticipant.push({
                  id: item,
                  status: "initiated",
                  hand_raise: false,
                  audio: false,
                  screenShare: false,
                });
              }
            } else {
              const prevParticipantItem = participant[isUserAlreadyExist];
              tmpParticipant.push({
                id: prevParticipantItem.id,
                status: "initiated",
                hand_raise: false,
                audio: false,
                screenShare: false,
              });
            }
          });
        }
      } else {
        const prevParticipant = callDetail.participantID;
        let groupParticipant = [...prevParticipant];

        removedDuplicateUsers.forEach((item) => {
          const isUserAlreadyExist = groupParticipant.findIndex(
            (filterItem) => filterItem.id === item,
          );
          if (isUserAlreadyExist === -1) {
            let particularAttendeeData = allAttendeeList?.find(
              (filterItem) => filterItem.user_id === item,
            );
            const onCallCheck = particularAttendeeData?.onCall ?? false;
            if (!onCallCheck) {
              tmpParticipant.push({
                id: item,
                status: "initiated",
                hand_raise: false,
                audio: false,
                screenShare: false,
              });
            }
          } else {
            const prevParticipantItem = groupParticipant[isUserAlreadyExist];
            tmpParticipant.push({
              id: prevParticipantItem.id,
              status: "initiated",
              hand_raise: false,
              audio: false,
              screenShare: false,
            });
          }
        });
      }
      NewCallDetail["user_added"] = true;
      const callAddedPayload = {
        company_id: callDetail?.company_id,
        id: callDetail?.id,
        participantID: tmpParticipant,
        receiverID: callDetail?.receiverID,
      };
      _addCallParticipants(callAddedPayload);
      _callDocUpdate(NewCallDetail);
      setSelectedOption(null);
      handleClose();
    } else {
      alert(alertMsg.emptyField);
    }
  };

  const handleChange = (option) => {
    setSelectedOption(option);
  };

  useEffect(() => {
    setArray(allAttendeeList);
  }, [allAttendeeList]);

  const setArray = (obj) => {
    let list = [];
    const prevParticipant = callDetail?.participantID ?? [];
    obj.forEach((v) => {
      const UserAlreadyExist = prevParticipant.filter(
        (filterItem) =>
          filterItem.id === v?.user_id && filterItem.status === "accepted",
      );
      if (UserAlreadyExist.length === 0) {
        let data = {
          value: v?.user_id,
          label: v.name,
          online: v.online,
          custom: true,
        };
        list.push(data);
      }
    });
    setAttendeeListForGroup(list);
    return list;
  };

  // const ref = useDetectClickOutside({
  //   onTriggered: () => console.log("close triggered"),
  // });
  const ref = useDetectClickOutside({ onTriggered: handleClose });

  const DropClose = (e) => {
    e.stopPropagation();
  };

  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return data.custom ? (
      <div ref={innerRef} {...innerProps}>
        <span className="d-flex align-items-center justify-content-between Invite-People-drop">
          {data.label}
          <span
            className={`status right-0 bottom-0 position-relative ${
              data.online ? "online" : ""
            } `}
          ></span>
        </span>
      </div>
    ) : (
      ""
    );
  };

  return (
    <>
      <div
        className="bg-white border-radius shadow index-3 position-absolute p-3 mt-2 w-300 top-100"
        ref={ref}
      >
        <Form>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>
              {globalStrings[selectedLanguage]?.$invitePeopleToCall}
            </Form.Label>
            <div onClick={DropClose}>
              <Select
                className="form-control py-0 px-2 whiteboard-form-control"
                isMulti={true}
                value={selectedOption}
                onChange={(e) => handleChange(e)}
                components={{ Option: CustomOption }}
                options={AttendeeListForGroup}
                classNamePrefix="select-menu-custom"
              />
            </div>
          </Form.Group>
          <Button
            type="submit"
            id="submit"
            variant="orange"
            className="ml-auto"
            disabled={!selectedOption || selectedOption.length === 0}
            onClick={(e) => {
              submitGroupUserForm(e);
            }}
          >
            {globalStrings[selectedLanguage]?.$add}
          </Button>
        </Form>
      </div>
    </>
  );
};

export default AddPeople;
